import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <path
        className="fill-change"
        fill="#9F9F9F"
        fillRule="nonzero"
        d="M39 10a2 2 0 0 1 2 2v16.5a1.5 1.5 0 0 1-3 0V13H16.5a1.5 1.5 0 0 1 0-3H39z"
      />
      <path
        className="stroke-change"
        stroke="#9F9F9F"
        strokeWidth="3"
        d="M9 17.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h24a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5H9z"
      />
      <path
        className="fill-change stroke-change"
        fill="#9F9F9F"
        stroke="#9F9F9F"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M18 23l7 4-7 4z"
      />
    </g>
  </svg>
);
